import { Spinner } from "flowbite-react";

export default function PageLoading() {
  return (
    <div className="flex h-screen flex-col items-center justify-center bg-white dark:bg-gray-875">
      <Spinner size="xl" color="purple" />
    </div>
  );
}
